import { CvsFilterInterface } from "../types";

type UsersFilterInterface = Omit<CvsFilterInterface, "active" | "inactive"> & {
  employment_status?: Array<"active" | "inactive">;
};

export function toUsersFilter(filters: CvsFilterInterface): UsersFilterInterface {
  const { active, inactive, ...usersFilter } = filters;
  const employmentStatus: Array<"active" | "inactive"> = [];

  if (active) employmentStatus.push("active");
  if (inactive) employmentStatus.push("inactive");

  return {
    ...usersFilter,
    ...(employmentStatus.length ? { employment_status: employmentStatus } : {}),
  };
}
